// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainPage_mainContainer__u2FCS"};